import { apiClient } from '@/api/apiClient'
import { Organization, OrganizationUpdatePayload } from '@/api/models/OrganizationModel'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

const ORGANIZATION_QUERY_KEY = 'organization'

export const useGetOrganization = (organizationId: string) => {
  return useQuery({
    queryKey: [ORGANIZATION_QUERY_KEY, organizationId],
    queryFn: async () => {
      const response = await apiClient.get<Organization>(`/v1/organizations/${organizationId}`)
      return response.data
    }
  })
}

export const useUpdateOrganization = (organizationId: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (payload: OrganizationUpdatePayload) => {
      const response = await apiClient.patch<Organization>(
        `/v1/organizations/${organizationId}`,
        payload
      )
      return response.data
    },
    onSuccess: data => {
      queryClient.setQueryData([ORGANIZATION_QUERY_KEY, organizationId], data)
    }
  })
}
